module.exports = __webpack_public_path__ + "static/img/200259.891d4f54.png";